module.exports = __webpack_public_path__ + "static/media/py.e74e3ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/py.png
// module id = 1964
// module chunks = 0